// Latin American Spanish translation overlay for Flight 67 passenger data.
// Unchanged proper nouns and non-descriptive data are inherited from the source.

export const passengerDataEs419 = {
	'1A': {
		height: '5 pies 4 pulgadas',
		eyes: 'Marrones',
		hair: 'Negro',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Latte helado' }, { item: 'Guía de estudio' }, { item: 'Cargador de teléfono' }],
		texts: ['¡Ya quiero que lleguen las vacaciones de primavera!', '¿Terminaste la tarea?', 'Mamá te manda saludos'],
	},
	'1B': {
		height: '5 pies 5 pulgadas',
		eyes: 'Marrones',
		hair: 'Castaño',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Lentes de sol' }, { item: 'Moca' }, { item: 'Revista' }],
		texts: ['¡El vuelo sale a tiempo!', 'Nos vemos en el área de reclamo de equipaje', 'Te quiero, mamá'],
	},
	'1C': {
		height: '5 pies 6 pulgadas',
		eyes: 'Azules',
		hair: 'Rubio',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Libro de texto' }, { item: 'Capuchino' }, { item: 'Almohada para el cuello' }],
		texts: ['El dormitorio está listo', 'La orientación es el lunes', '¡Ya te extraño!'],
	},
	'1D': {
		height: '5 pies 10 pulgadas',
		eyes: 'Azules',
		hair: 'Rubio',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Manta de viaje' }, { item: 'Botella de agua de 32 oz' }, { item: 'Sándwich' }],
		texts: ['Voy tarde a la puerta de embarque', 'Guárdame un asiento', 'Este aeropuerto es enorme'],
	},

	'2A': {
		height: '5 pies 3 pulgadas',
		eyes: 'Marrones',
		hair: 'Teñido de rosa',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Audífonos' }, { item: 'Novela' }, { item: 'Té verde' }],
		texts: ['¡Ya casi llego!', '¿Empacaste bocadillos?', 'Es la puerta B12, ¿verdad?'],
	},
	'2B': {
		height: '5 pies 11 pulgadas',
		eyes: 'Azules',
		hair: 'Castaño',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Mochila' }, { item: 'Café americano' }, { item: 'Mezcla de frutos secos' }],
		texts: ['¿Viaje de snowboard el próximo mes?', 'El vuelo se retrasó 30 min', 'Voy por un café'],
	},
	'2C': {
		height: '5 pies 5 pulgadas',
		eyes: 'Azules',
		hair: 'Teñido de turquesa',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Diario' }, { item: 'Batido' }, { item: 'Antifaz para dormir' }],
		texts: ['Ya terminé lo del trabajo', '¡Por fin de vacaciones!', '¡Nos vemos pronto!'],
	},
	'2D': {
		height: '6 pies',
		eyes: 'Marrones',
		hair: 'Negro',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Juego para Switch' }, { item: 'Porción de pizza' }, { item: 'Cable USB' }],
		texts: ['Estoy aburrido en el aeropuerto', '¿Descargaste ese juego?', 'Escala de 2 horas, uf'],
	},

	'3A': {
		height: '5 pies 7 pulgadas',
		eyes: 'Azules',
		hair: 'Castaño',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Revista jurídica' }, { item: 'Espresso doble' }, { item: 'Bufanda' }],
		texts: ['Ya presenté el escrito', 'La entrevista salió muy bien', '¡Celebramos esta noche!'],
	},
	'3B': {
		height: '6 pies 1 pulgada',
		eyes: 'Verdes',
		hair: 'Castaño',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Balón de básquetbol' }, { item: 'Menú combinado' }, { item: 'Chicle' }],
		texts: ['El partido es esta noche a las 8', '¿Pasas por mí?', 'Juguemos básquet mañana'],
	},
	'3C': {
		height: '5 pies 4 pulgadas',
		eyes: 'Marrones',
		hair: 'Pelirrojo',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Cuerdas para guitarra' }, { item: 'Disco' }, { item: 'Latte chai' }],
		texts: ['¡El concierto estuvo increíble!', 'La nueva canción sale pronto', 'Ya reservé tiempo en el estudio'],
	},
	'3D': {
		height: '5 pies 9 pulgadas',
		eyes: 'Azules',
		hair: 'Pelirrojo',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Cera para tabla de surf' }, { item: 'Burrito' }, { item: 'Sandalias' }],
		texts: [
			'Las olas están increíbles hoy',
			'¿Vamos a la playa a las 6?',
			'La competencia de surf es la próxima semana',
		],
	},

	'4A': {
		height: '5 pies 6 pulgadas',
		eyes: 'Verdes',
		hair: 'Castaño',
		hometown: 'Filadelfia, PA',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Uniforme médico' }, { item: 'Ensalada' }, { item: 'Revista médica' }],
		texts: ['El turno empieza a las 7', 'El paciente está mejor', '¡Por fin un día libre!'],
	},
	'4B': {
		height: '5 pies 10 pulgadas',
		eyes: 'Marrones',
		hair: 'Negro',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Soporte para laptop' }, { item: 'Café preparado en frío' }, { item: 'Barra de proteína' }],
		texts: ['El código ya está en producción', 'Reunión a las 3', 'Hoy trabajo a distancia'],
	},
	'4C': {
		height: '5 pies 8 pulgadas',
		eyes: 'Color avellana',
		hair: 'Rubio',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Kit de maquillaje' }, { item: 'Cupcake' }, { item: 'Vestido' }],
		texts: ['El contenido está listo', '¡Colaboración mañana!', 'Me encanta el nuevo filtro'],
	},
	'4D': {
		height: '6 pies 2 pulgadas',
		eyes: 'Marrones',
		hair: 'Pelirrojo',
		hometown: 'Los Ángeles, CA',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Filtro para lente' }, { item: 'Café Red Eye' }, { item: 'Cuaderno de bocetos' }],
		texts: ['La fiesta de fin de rodaje es esta noche', 'El guion se ve bien', 'La hora de llamado es a las 5 a. m.'],
	},

	'5A': {
		height: '5 pies 5 pulgadas',
		eyes: 'Marrones',
		hair: 'Negro',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Agenda' }, { item: 'Tazón de açaí' }, { item: 'Etiqueta para equipaje' }],
		texts: ['¡Lanzamos la campaña!', 'Las cifras se ven muy bien', 'Al cliente le encantó'],
	},
	'5B': {
		height: '5 pies 11 pulgadas',
		eyes: 'Verdes',
		hair: 'Negro',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Membresía' }, { item: 'Batido de proteína' }, { item: 'Tenis para correr' }],
		texts: ['¡Nuevo récord personal en peso muerto!', 'Mañana toca pierna', 'La dieta empieza el lunes'],
	},
	'5C': {
		height: '5 pies 7 pulgadas',
		eyes: 'Azules',
		hair: 'Pelirrojo',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Manual del automóvil' }, { item: 'Desayuno' }, { item: 'Reloj' }],
		texts: ['¡Ya arreglaron el auto!', 'Voy a reunirme con el equipo', '¡Orgullo de Detroit!'],
	},
	'5D': {
		height: '6 pies',
		eyes: 'Azules',
		hair: 'Castaño',
		hometown: 'Nueva York, NY',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Guía de inversiones' }, { item: 'Café flat white' }, { item: 'Corbata' }],
		texts: ['Los mercados están al alza', '¡Cerramos el trato!', 'Se viene el bono'],
	},

	'6A': {
		height: '5 pies 4 pulgadas',
		eyes: 'Azules',
		hair: 'Rubio',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Bolsas reutilizables' }, { item: 'Wrap vegano' }, { item: 'Libro sobre sostenibilidad' }],
		texts: ['¡La recaudación de fondos fue un éxito!', 'Limpieza de playa el sábado', 'Salvando el planeta'],
	},
	'6B': {
		height: '5 pies 10 pulgadas',
		eyes: 'Marrones',
		hair: 'Negro',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Brocas' }, { item: 'Pizza grande' }, { item: 'Pintura' }],
		texts: ['¡Proyecto terminado!', 'Necesito más clavos', 'La casa se ve genial'],
	},
	'6C': {
		height: '5 pies 6 pulgadas',
		eyes: 'Verdes',
		hair: 'Rubio',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Juego de decoración' }, { item: 'Bléiser' }, { item: 'Café helado' }],
		texts: ['¡Vendimos la casa!', 'Hay una visita a las 2 p. m.', 'Ya viene la comisión'],
	},
	'6D': {
		height: '6 pies 1 pulgada',
		eyes: 'Azules',
		hair: 'Castaño',
		purchases: [{ item: 'Juego de salsas' }, { item: 'Cena de ribeye' }, { item: 'Camiseta de los Chiefs' }],
		texts: ['¡Reino de los Chiefs!', '¿Hacemos una parrillada este fin de semana?', 'Listo para el día del partido'],
	},

	'7A': {
		height: '5 pies 5 pulgadas',
		eyes: 'Marrones',
		hair: 'Castaño',
		passport: 'Estados Unidos',
		purchases: [
			{ item: 'Decoración para el salón de clases' },
			{ item: 'Té de hierbas' },
			{ item: 'Libros infantiles' },
		],
		texts: [
			'A los niños les encantó la lección',
			'Mañana hay reunión con los padres',
			'¡Ya casi llegan las vacaciones de verano!',
		],
	},
	'7B': {
		height: '5 pies 9 pulgadas',
		eyes: 'Verdes',
		hair: 'Negro',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Estetoscopio' }, { item: 'Tazón de proteína' }, { item: 'Texto de medicina' }],
		texts: ['Terminó el turno de 12 horas', 'Hoy salvé una vida', 'Necesito un café urgentemente'],
	},
	'7C': {
		height: '5 pies 8 pulgadas',
		eyes: 'Azules',
		hair: 'Rubio',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Tapete de yoga' }, { item: 'Jugo verde' }, { item: 'Leggings' }],
		texts: ['¡Namasté a todos!', 'Clase a las 6 a. m.', 'Hoy me siento en paz'],
	},
	'7D': {
		height: '6 pies',
		eyes: 'Marrones',
		hair: 'Castaño',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Guantes' }, { item: 'Combustible' }, { item: 'Bebida energética' }],
		texts: ['Mañana toca pista', '¡Nuevo récord de vuelta!', 'Listo para el día de la carrera'],
	},

	'8A': {
		height: '5 pies 4 pulgadas',
		eyes: 'Color avellana',
		hair: 'Castaño',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Muestras de tela' }, { item: 'Macarons' }, { item: 'Broche vintage' }],
		texts: ['¡Aprobaron el diseño!', 'La reunión con el cliente salió muy bien', 'Me encanta esta estética'],
	},
	'8B': {
		height: '5 pies 11 pulgadas',
		eyes: 'Azules',
		hair: 'Rubio',
		purchases: [{ item: 'Botas de senderismo' }, { item: 'Suministros' }, { item: 'Estacas para tienda de campaña' }],
		texts: ['¡Llegué a la cumbre!', 'El sendero estaba precioso', 'Próxima montaña: Rainier'],
	},
	'8C': {
		height: '5 pies 6 pulgadas',
		eyes: 'Verdes',
		hair: 'Pelirrojo',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Lúpulo' }, { item: 'Miel local' }, { item: 'Frascos Mason' }],
		texts: ['¡La nueva IPA está lista!', 'La sala de degustación está llena', '¡Salud a todos!'],
	},
	'8D': {
		height: '6 pies 2 pulgadas',
		eyes: 'Marrones',
		hair: 'Negro',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Juego de púas para guitarra' }, { item: 'Cerdo deshebrado' }, { item: 'Álbum de BB King' }],
		texts: ['Beale Street esta noche', 'Jam de blues a las 9', 'La música es vida'],
	},

	'9A': {
		height: '5 pies 5 pulgadas',
		eyes: 'Marrones',
		hair: 'Negro',
		hometown: 'Nueva Orleans, LA',
		passport: 'Estados Unidos',
		purchases: [
			{ item: 'Juego de cuchillos' },
			{ item: 'Mezcla de especias cajún' },
			{ item: 'Cangrejos de río frescos' },
		],
		texts: ['¡La cocina está lista!', 'El nuevo menú sale pronto', '¡Que sigan los buenos tiempos!'],
	},
	'9B': {
		height: '5 pies 10 pulgadas',
		eyes: 'Azules',
		hair: 'Castaño',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Monitor portátil' }, { item: 'Café filtrado manual' }, { item: 'Pase por un día' }],
		texts: ['¡Financiamiento asegurado!', 'La presentación salió muy bien', 'Vida de startup'],
	},
	'9C': {
		height: '5 pies 7 pulgadas',
		eyes: 'Color avellana',
		hair: 'Rubio',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Maletín' }, { item: 'Tazón de granos' }, { item: 'Libro de finanzas' }],
		texts: ['La cartera subió un 12 %', 'Cena con el cliente esta noche', 'Terminó la revisión trimestral'],
	},
	'9D': {
		height: '6 pies 1 pulgada',
		eyes: 'Azules',
		hair: 'Rubio',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Pase para telesilla' }, { item: 'Gafas de esquí' }, { item: 'Calentadores de manos' }],
		texts: ['¡Día de nieve polvo!', 'Pista de diamante negro', 'Viviendo el sueño'],
	},

	'10A': {
		height: '5 pies 4 pulgadas',
		eyes: 'Azules',
		hair: 'Castaño',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Pañales' }, { item: 'Comida para bebé' }, { item: 'Peluche' }],
		texts: ['¡El primer vuelo del bebé!', 'Empaca la pañalera', '¡Ya casi llegamos, abuela!'],
	},
	'10B': {
		height: '5 pies 9 pulgadas',
		eyes: 'Marrones',
		hair: 'Negro',
		purchases: [{ item: 'Fichas de póquer' }, { item: 'Filete miñón' }, { item: 'Lentes de sol' }],
		texts: ['¡Me gané el premio mayor!', 'Fiesta en la piscina del Encore', 'Lo que pasa en Las Vegas...'],
	},
	'10C': {
		height: '5 pies 6 pulgadas',
		eyes: 'Azules',
		hair: 'Pelirrojo',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Estudios de casos' }, { item: 'Té Earl Grey' }, { item: 'Aretes de perlas' }],
		texts: ['¡Caso desestimado!', 'Declaración mañana', 'Se hizo justicia'],
	},
	'10D': {
		height: '6 pies',
		eyes: 'Azules',
		hair: 'Canoso',
		hometown: 'San José, CA',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Reloj inteligente' }, { item: 'Café nitro preparado en frío' }, { item: 'Libro sobre IA' }],
		texts: [
			'La oferta pública inicial será el próximo trimestre',
			'Reunión de la junta a las 4',
			'Conversaciones sobre la adquisición',
		],
	},

	'11A': {
		height: '5 pies 5 pulgadas',
		eyes: 'Color avellana',
		hair: 'Rubio',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Premios para perro' }, { item: 'Tostada con aguacate' }, { item: 'Cárdigan' }],
		texts: ['Ya extraño a mi perrito', 'La persona que cuida la casa es genial', 'Modo vacaciones ACTIVADO'],
	},
	'11B': {
		height: '5 pies 7 pulgadas',
		eyes: 'Azules',
		hair: 'Rubio',
		passport: 'Estados Unidos',
		purchases: [
			{ item: 'Kit para medir la presión arterial' },
			{ item: 'Ensalada de pollo' },
			{ item: 'Guía de bienestar' },
		],
		texts: ['¡El paciente se recuperó!', 'La clínica abrirá pronto', 'La salud es riqueza'],
	},
	'11C': {
		height: '5 pies 11 pulgadas',
		eyes: 'Verdes',
		hair: 'Castaño',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Kit para hacer cerveza' }, { item: 'Cheddar añejo' }, { item: 'Gorra de los Packers' }],
		texts: ['¡Vamos, Packers!', 'Visita a la cervecería el sábado', 'Las cuajadas de queso son lo máximo'],
	},
	'11D': {
		height: '6 pies',
		eyes: 'Marrones',
		hair: 'Negro',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Calculadora' }, { item: 'Hamburguesa con chile verde' }, { item: 'Manual de ingeniería' }],
		texts: ['Aprobaron el diseño del puente', 'Terminó la inspección del sitio', 'El proyecto va según lo programado'],
	},

	'12A': {
		height: '5 pies 6 pulgadas',
		eyes: 'Azules',
		hair: 'Rubio',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Carpetas' }, { item: 'Sándwich club' }, { item: 'Blusa' }],
		texts: ['Renovaron la póliza', 'La reunión cambió a las 3', '¡Excelente trimestre!'],
	},
	'12B': {
		height: '5 pies 4 pulgadas',
		eyes: 'Color avellana',
		hair: 'Castaño',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Jarrón vintage' }, { item: 'Juego de scones' }, { item: 'Libro de historia' }],
		texts: ['¡Encontré un tesoro!', 'Venta de bienes mañana', 'Me encanta esta antigüedad'],
	},
	'12C': {
		height: '5 pies 10 pulgadas',
		eyes: 'Azules',
		hair: 'Negro',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Botas de trabajo' }, { item: 'Burrito de desayuno' }, { item: 'Linterna' }],
		texts: ['El turno termina a las 6', 'Descubrieron una nueva veta', 'La seguridad siempre es lo primero'],
	},
	'12D': {
		height: '6 pies 1 pulgada',
		eyes: 'Marrones',
		hair: 'Blanco',
		passport: 'Emiratos Árabes Unidos',
		purchases: [{ item: 'Camiseta de los Steelers' }, { item: 'Plato de pierogi' }, { item: 'Máscara para soldar' }],
		texts: ['¡Vamos, Steelers!', 'La planta funciona sin problemas', 'Cena familiar el domingo'],
	},

	'13B': {
		height: '5 pies 11 pulgadas',
		eyes: 'Azules',
		hair: 'Rubio',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Café negro' }, { item: 'Novela de misterio' }, { item: 'Cargador portátil' }],
		texts: [
			'¿Quieres un poco de agua?',
			'Qué vuelo tan loco. ¡De verdad tengo que ir al baño!',
			'La fecha límite para la nota es mañana',
		],
	},
	'13C': {
		height: '5 pies 5 pulgadas',
		eyes: 'Verdes',
		hair: 'Rubio',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Orejas de Mickey' }, { item: 'Pierna de pavo' }, { item: 'Álbum de fotos' }],
		texts: ['¡Los niños se divirtieron muchísimo!', 'Vacaciones mágicas', 'Pronto estaremos de vuelta en casa'],
	},
	'13D': {
		height: '5 pies 9 pulgadas',
		eyes: 'Verdes',
		hair: 'Canoso',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Calculadora' }, { item: 'Café de filtro' }, { item: 'Guía de impuestos' }],
		texts: ['La temporada de impuestos está a tope', '¡Declaraciones presentadas!', 'Auditoría terminada'],
	},

	'14A': {
		height: '5 pies 4 pulgadas',
		eyes: 'Azules',
		hair: 'Canoso',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Semillas de flores' }, { item: 'Té de manzanilla' }, { item: 'Agujas para tejer' }],
		texts: ['¡El jardín está floreciendo!', 'Los nietos vienen de visita', 'Hice galletas recién horneadas'],
	},
	'14B': {
		height: '6 pies',
		eyes: 'Marrones',
		hair: 'Canoso',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Armónica' }, { item: 'Plato de brisket' }, { item: 'Álbum de Johnny Cash' }],
		texts: ['¡El Opry estuvo increíble!', 'Grabamos la próxima semana', 'Música country para siempre'],
	},
	'14C': {
		height: '5 pies 5 pulgadas',
		eyes: 'Color avellana',
		hair: 'Castaño',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Premios para caballo' }, { item: 'Hot Brown' }, { item: 'Guía para el cuidado de caballos' }],
		texts: ['¡Temporada del Derby!', '¡El caballo ganó hoy!', 'Bluegrass es mi hogar'],
	},
	'14D': {
		height: '5 pies 6 pulgadas',
		eyes: 'Marrones',
		hair: 'Canoso',
		passport: 'Estados Unidos',
		purchases: [{ item: 'Cuerda' }, { item: 'Pasteles de cangrejo' }, { item: 'Brújula' }],
		texts: ['¡El barco está listo!', 'Navegamos el domingo', 'La bahía es preciosa'],
	},
}
